export const DEFAULT_BOOKING_GROUP_SIZE = 2;
export const DEFAULT_BOOKING_DURATION = 120;
export const BOOKING_REFERENCE_LENGTH = 8;
